import { render, staticRenderFns } from "./opciones.vue?vue&type=template&id=539fbab7&"
import script from "./opciones.vue?vue&type=script&lang=js&"
export * from "./opciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports